

import { FormManager } from "./Forms/formManager";
import { IframeMessaging } from "./Generals/iframeMessaging";





  export async function init() {




    let userEmail = getUrlParams("email");
    console.log('init');

    //init form manager
    let formManager = new FormManager();
    await formManager.init();

    //send email to form manager
    let iframeMessaging = new IframeMessaging();
  }


  function getUrlParams(paramName: string) {
    const params = new URLSearchParams(window.location.search);
    return params.get(paramName);
  }


window.addEventListener("load", async () => {
  console.log("Ben Script Loaded");
  await init();
})